// extracted by mini-css-extract-plugin
export default {"melodyVideo":"PM-z","isFullWidth":"QM-z","landingPageVideo":"RM-z","play":"SM-z","iframeVideo":"TM-z","playHidden":"UM-z","fullwidth":"VM-z"};